import { defineComponentStyle } from "../../core"

export const formatByteStyle = defineComponentStyle({})

export type FormatByteStyle = typeof formatByteStyle
